import { render, staticRenderFns } from "./Bids.vue?vue&type=template&id=6cb7d3e8&scoped=true"
import script from "./Bids.vue?vue&type=script&lang=ts"
export * from "./Bids.vue?vue&type=script&lang=ts"
import style0 from "./Bids.vue?vue&type=style&index=0&id=6cb7d3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7d3e8",
  null
  
)

export default component.exports